/* AdVille, Molinari Gioielli. I filtri del catalogo.
   Lo stesso comportamento del prototipo approvato: un filtro per volta, le
   schede che non passano si nascondono, e il contatore in alto si aggiorna.

   Due cose che non erano nel prototipo e qui servono:
   - si riattacca a shopify:section:load, o dentro il tema editor il cliente
     cambia un'impostazione, la sezione viene ridisegnata e i filtri muoiono;
   - si chiama da solo, sia che il documento sia gia' pronto sia che non lo sia.
     Uno script caricato che nessuno richiama non sembra rotto: sembra finito. */
(function () {
  /* Guardia: se il file finisce in pagina due volte, la seconda non fa niente.
     Senza, ogni clic su un filtro scatterebbe due volte. */
  if (window.AVMG) { return; }
  function collega(radice) {
    var bottoni = radice.querySelectorAll('.filtro');
    if (!bottoni.length) { return; }
    var conta = radice.querySelector('.conta');
    bottoni.forEach(function (b) {
      b.addEventListener('click', function () {
        bottoni.forEach(function (x) { x.classList.remove('attivo'); });
        b.classList.add('attivo');
        var f = b.dataset.f || 'tutti', visti = 0;
        radice.querySelectorAll('.scheda').forEach(function (s) {
          var ok = f === 'tutti'
            || (f.indexOf('tipo:') === 0 && s.dataset.tipo === f.slice(5))
            || (f.indexOf('mat:') === 0 && s.dataset.mat === f.slice(4))
            || (f.indexOf('prezzo:') === 0 && parseFloat(s.dataset.prezzo) < parseFloat(f.slice(7)));
          s.style.display = ok ? '' : 'none';
          if (ok) { visti++; }
        });
        if (conta) {
          conta.textContent = visti + (visti === 1 ? ' gioiello' : ' gioielli');
        }
      });
    });
  }

  /* La galleria della scheda prodotto.

     Prima c'era una foto sola e le miniature le cambiavano la sorgente: da
     telefono non si scorreva niente col dito, e su un gioiello la seconda
     foto e' meta' della decisione. Ora le foto stanno in fila e scorrono con
     lo scatto, che e' una cosa che il browser fa da solo; le miniature
     portano alla foto giusta invece di sostituirla, e si accende quella che
     si sta guardando.

     Niente piu' giochi con src e srcset: image_tag genera sempre un srcset,
     e cambiare solo .src lasciava l'immagine dov'era senza un errore. Le
     immagini ora ci sono tutte, ognuna con la sua. */
  function galleria(radice) {
    var fila = radice.querySelector('[data-av-fila]');
    var mini = radice.querySelectorAll('[data-av-mini]');
    if (!fila) { return; }
    var foto = fila.querySelectorAll('img');

    function accendi(n) {
      mini.forEach(function (x, i) {
        x.setAttribute('aria-current', i === n ? 'true' : 'false');
      });
    }

    mini.forEach(function (b) {
      b.addEventListener('click', function () {
        var n = Number(b.dataset.indice || 0);
        if (!foto[n]) { return; }
        fila.scrollTo({left: foto[n].offsetLeft - fila.offsetLeft, behavior: 'smooth'});
        accendi(n);
      });
    });

    /* mentre si scorre col dito, la miniatura accesa segue */
    var attesa = null;
    fila.addEventListener('scroll', function () {
      if (attesa) { clearTimeout(attesa); }
      attesa = setTimeout(function () {
        var largo = fila.clientWidth || 1;
        accendi(Math.round(fila.scrollLeft / largo));
      }, 90);
    });
  }

  /* La spedizione assicurata: un prodotto vero che la cliente paga.

     TUTTO passa dal tema, in entrambi i versi, e non e un vezzo:
     - per METTERLA si fa scattare un collegamento nascosto con gli agganci
       del tema. Prima lo facevamo con una fetch nostra piu un
       window.location.reload(), e il reload chiudeva il cassetto nel momento
       esatto in cui si era appena aperto: la cliente vedeva la pagina
       ricaricarsi e il carrello sparire.
     - per TOGLIERLA si clicca la X che il tema ha gia messo sulla riga di
       quell articolo dentro il cassetto. Il tema sa aggiornare il suo
       elenco, i suoi totali e i suoi sconti; noi no.
     Fuori dal cassetto, sulla pagina del carrello, non c e nessuna X nostra
     da cliccare: li si usa la chiamata diretta e si ricarica, che su una
     pagina intera e il comportamento normale.

     PRESELEZIONATA, su richiesta del cliente. Scatta una volta per visita e
     solo a carrello non vuoto. Se la cliente la toglie non torna: l abbiamo
     segnato in sessionStorage, e rimetterla dentro al caricamento dopo
     sarebbe un supplemento imposto, non una proposta. */
  var PROT_TOLTA = 'av-mg-protezione-tolta';

  /* UNA CODA SOLA per tutto quello che tocca il carrello.

     Misurato: il box aggiungeva i suoi tre pezzi uno ogni 900 ms, e ogni
     aggiunta faceva ridisegnare l elenco del cassetto; il nostro
     sorvegliante leggeva l elenco e, vedendo che la spedizione assicurata
     non c era, la aggiungeva. Quell aggiunta partiva in mezzo alle altre, e
     il carrello ne perdeva una: finivano dentro due pezzi su tre, senza
     sconto e senza un errore. Il totale sembrava solo sbagliato.

     Quindi: chi aggiunge alza la bandierina, chi vuole aggiungere aspetta.
     E non si aspetta a tempo, si aspetta il CARRELLO: si chiede /cart.js
     finche la variante non c e. Un ritardo fisso e una scommessa sulla
     rete del cliente. */
  var inCorsoCarrello = 0;

  function carrelloOccupato() { return inCorsoCarrello > 0; }

  function attendiVariante(variante, entro, poi) {
    var scaduto = Date.now() + (entro || 6000);
    (function guarda() {
      fetch('/cart.js', {headers: {'Accept': 'application/json'}})
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var c_e = (c.items || []).some(function (i) {
            return String(i.variant_id) === String(variante);
          });
          if (c_e || Date.now() > scaduto) { poi(c_e); return; }
          setTimeout(guarda, 250);
        })
        .catch(function () { poi(false); });
    }());
  }


  function protLeggiCassetto(variante) {
    /* lo stato vero sta nell elenco del cassetto, che il tema ridisegna a
       ogni cambio: l attributo scritto da Liquid invecchia al primo clic */
    var lista = document.querySelector('#t4s-mini_cart .t4s-mini_cart__items');
    if (!lista) { return null; }
    var righe = lista.querySelectorAll('.t4s-mini_cart__item');
    var dentro = false, altri = 0;
    for (var i = 0; i < righe.length; i++) {
      var x = righe[i].querySelector('[data-cart-remove][data-id]');
      var suo = x && String(x.dataset.id).split(':')[0] === String(variante);
      if (suo) { dentro = true; } else { altri += 1; }
    }
    /* "articoli" sono i GIOIELLI, non le righe: la spedizione assicurata non
       si conta da sola. Se no, togliendo l'ultimo gioiello il carrello
       resterebbe con dentro il solo supplemento e la casella continuerebbe a
       dire che c'e' qualcosa da assicurare. */
    return { articoli: altri, dentro: dentro };
  }

  function protezione(radice) {
    var fuori = radice.closest('.av-mg-prot-fuori') || radice.parentNode;
    var btn = radice.querySelector('.segno');
    if (!btn || radice.dataset.legato) { return; }
    radice.dataset.legato = '1';
    var variante = radice.dataset.variante;
    var metti = fuori.querySelector('[data-av-prot-metti]');

    function togli() {
      var x = null;
      document.querySelectorAll('#t4s-mini_cart [data-cart-remove][data-id]').forEach(function (n) {
        if (String(n.dataset.id).split(':')[0] === String(variante)) { x = n; }
      });
      if (x) { x.click(); return; }
      /* niente cassetto: pagina del carrello */
      fetch('/cart/change.js', {method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({id: String(variante), quantity: 0})})
        .then(function () { window.location.reload(); })
        .catch(function () { radice.dataset.occupato = ''; });
    }

    function aggiungi() {
      if (metti) { metti.click(); return; }
      fetch('/cart/add.js', {method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({items: [{id: Number(variante), quantity: 1}]})})
        .then(function () { window.location.reload(); })
        .catch(function () { radice.dataset.occupato = ''; });
    }

    btn.addEventListener('click', function () {
      if (radice.dataset.occupato) { return; }
      radice.dataset.occupato = '1';
      setTimeout(function () { radice.dataset.occupato = ''; }, 1500);
      inCorsoCarrello += 1;
      var libera = function () { inCorsoCarrello -= 1; };
      if (radice.dataset.dentro === 'true') {
        try { sessionStorage.setItem(PROT_TOLTA, '1'); } catch (e) {}
        togli();
        setTimeout(libera, 1500);
      } else {
        try { sessionStorage.removeItem(PROT_TOLTA); } catch (e) {}
        aggiungi();
        attendiVariante(variante, 6000, libera);
      }
    });

    radice.AVMGaggiungi = aggiungi;
    sincronizzaProt(radice);
  }

  function sincronizzaProt(radice) {
    var fuori = radice.closest('.av-mg-prot-fuori') || radice.parentNode;
    var stato = protLeggiCassetto(radice.dataset.variante);
    var dentro, articoli;
    if (stato) {
      dentro = stato.dentro;
      articoli = stato.articoli;
    } else {
      dentro = radice.dataset.dentro === 'true';
      articoli = Number(radice.dataset.articoli || 0);
    }

    radice.dataset.dentro = dentro ? 'true' : 'false';
    radice.classList.toggle('presa', dentro);
    var btn = radice.querySelector('.segno');
    if (btn) { btn.setAttribute('aria-checked', dentro ? 'true' : 'false'); }
    /* Senza gioielli la striscia non ha senso: non si assicura niente. Resta
       pero' visibile se la spedizione assicurata e' dentro da sola, o la
       cliente non avrebbe piu' da nessuna parte il modo di toglierla. */
    var mostra = articoli > 0 || dentro;
    if (fuori.hasAttribute('hidden') === mostra) {
      if (mostra) { fuori.removeAttribute('hidden'); }
      else { fuori.setAttribute('hidden', ''); }
    }

    if (dentro || articoli === 0) { return; }
    if (radice.dataset.auto !== 'true') { return; }
    if (radice.dataset.gia) { return; }
    /* mai in mezzo a un altra aggiunta: la seconda mangia la prima */
    if (carrelloOccupato()) { return; }
    try { if (sessionStorage.getItem(PROT_TOLTA) === '1') { return; } } catch (e) { return; }
    radice.dataset.gia = '1';
    if (radice.AVMGaggiungi) {
      inCorsoCarrello += 1;
      radice.AVMGaggiungi();
      attendiVariante(radice.dataset.variante, 6000, function () { inCorsoCarrello -= 1; });
    }
  }

  /* "Spesso comprati insieme", sotto il bottone di acquisto.

     Tre cose che il box deve fare bene, perche sbagliarne una gli toglie
     il motivo di esistere:

     1. il TOTALE comprende sempre il prodotto della pagina. E lui quello
        che la cliente sta comprando: un totale che lo salta mostra una
        cifra piu bassa del vero e, due secondi dopo, un carrello piu alto.
     2. la VARIANTE si scegle da dentro il box. Senza, si aggiunge la prima
        disponibile e il colore sbagliato si scopre nell ordine.
     3. lo SCONTO e quello vero. La scala arriva da data-scala, generata
        dagli sconti automatici attivi dello store. Se non c e nessuno
        scaglione il box non promette niente, invece di promettere zero.

     COME si aggiunge. Per i compagni si fa scattare un collegamento
     nascosto con gli agganci del tema, uno per variante: il tema ci mette
     la sua validazione, il suo stato e il suo cassetto. Una chiamata nostra
     a /cart/add.js aggiungerebbe la roba lasciando il cassetto chiuso, e la
     cliente non vedrebbe succedere niente.
     Per il prodotto della pagina invece si invia il SUO form, che porta con
     se la variante scelta in pagina e la quantita. */
  function insieme(radice) {
    var caselle = Array.prototype.slice.call(radice.querySelectorAll('[data-av-pezzo]'));
    var totale = radice.querySelector('[data-av-totale]');
    var pieno = radice.querySelector('[data-av-pieno]');
    var risparmio = radice.querySelector('[data-av-risparmio]');
    var prendi = radice.querySelector('[data-av-prendi]');
    if (!caselle.length || !prendi || !totale) { return; }

    /* il formato del prezzo lo decide il negozio, non noi: si legge dalla
       cifra che Liquid ha gia scritto e se ne tiene la forma */
    var modello = totale.textContent.trim();
    var cifre = modello.replace(/[0-9]/g, '#');
    var virgola = modello.indexOf(',') > -1 && modello.indexOf('.') === -1;

    function soldi(centesimi) {
      var v = (centesimi / 100).toFixed(2);
      return cifre.replace(/#+[.,]?#*/, virgola ? v.replace('.', ',') : v);
    }

    /* La scala: "2=percento:10,3=euro:19.5;percento:13.33"

       Su uno stesso scaglione possono esserci PIU' offerte, una a importo
       fisso e una a percentuale. Shopify ne applica una sola, la migliore, e
       quale sia dipende da quanto c'e' nel carrello: 19,50 euro battono il
       13,33% su tre pezzi da 39,90 e perdono su tre pezzi da 90.

       Il box promette il MINORE dei due. E' il solo numero che la cassa non
       puo' smentire al ribasso: alla peggio la cliente trova quello, alla
       meglio trova di piu'. Promettere il maggiore vorrebbe dire, su certi
       carrelli, scrivere una cifra che poi non arriva. */
    var scala = [];
    (radice.dataset.scala || '').split(',').forEach(function (r) {
      var pezzo = r.split('=');
      if (pezzo.length < 2 || !pezzo[0]) { return; }
      var offerte = [];
      pezzo[1].split(';').forEach(function (o) {
        var p = o.split(':');
        if (p.length < 2) { return; }
        offerte.push({ tipo: p[0], quanto: Number(p[1]) });
      });
      if (offerte.length) { scala.push({ pezzi: Number(pezzo[0]), offerte: offerte }); }
    });
    scala.sort(function (a, b) { return a.pezzi - b.pezzi; });

    /* quanto toglie un'offerta su una certa somma, in centesimi */
    function taglioDi(o, somma) {
      return o.tipo === 'percento' ? Math.round(somma * o.quanto / 100)
                                   : Math.round(o.quanto * 100);
    }

    /* Lo scaglione raggiunto: non si somma al precedente, lo sostituisce. */
    function scaglione(pezzi) {
      var vinto = null;
      for (var i = 0; i < scala.length; i++) {
        if (pezzi >= scala[i].pezzi) { vinto = scala[i]; }
      }
      return vinto;
    }

    /* il minimo garantito su quello scaglione */
    function minimoDi(s, somma) {
      var meno = null;
      for (var i = 0; i < s.offerte.length; i++) {
        var q = taglioDi(s.offerte[i], somma);
        if (meno === null || q < meno) { meno = q; }
      }
      return meno || 0;
    }

    function conta() {
      var somma = 0, pezzi = 0;
      caselle.forEach(function (c) {
        if (!c.checked) { return; }
        somma += Number(c.dataset.prezzo || 0);
        pezzi += 1;
      });
      var s = scaglione(pezzi);
      var taglio = s ? minimoDi(s, somma) : 0;
      if (taglio > somma) { taglio = somma; }

      totale.textContent = soldi(somma - taglio);
      if (pieno) { pieno.textContent = taglio > 0 ? soldi(somma) : ''; }
      if (risparmio) {
        if (taglio > 0) {
          risparmio.textContent = (risparmio.dataset.risparmi || 'Risparmi')
            .replace('%s', soldi(taglio));
        } else {
          /* niente sconto ancora: si dice quanti pezzi servono, non si
             promette una cifra che la cassa non darebbe */
          var pros = null;
          for (var i = 0; i < scala.length; i++) {
            if (scala[i].pezzi > pezzi) { pros = scala[i]; break; }
          }
          if (pros) {
            var manca = pros.pezzi - pezzi;
            /* quanto varrebbe lo scaglione dopo, sul carrello di adesso piu'
               i pezzi che mancano: una stima onesta, non una percentuale
               nuda che la cliente non sa su cosa si applichi */
            var medio = pezzi > 0 ? somma / pezzi : 0;
            var q = soldi(minimoDi(pros, somma + medio * manca));
            /* "Aggiungi 1 prodotti" e il genere di dettaglio che fa sembrare
               tradotto a macchina un negozio: la frase al singolare e sua */
            var frase = manca === 1
              ? (risparmio.dataset.manca1 || risparmio.dataset.manca || 'Aggiungi un prodotto per %s')
              : (risparmio.dataset.manca || 'Aggiungi %n prodotti per %s');
            risparmio.textContent = frase.replace('%n', manca).replace('%s', q);
          } else {
            risparmio.textContent = '';
          }
        }
      }
    }

    caselle.forEach(function (c) { c.addEventListener('change', conta); });

    /* La variante. Il select sta dentro la label, quindi aprirlo
       toglierebbe la spunta: il clic si ferma qui. */
    radice.querySelectorAll('[data-av-variante]').forEach(function (sel) {
      /* solo stopPropagation: un preventDefault qui impedirebbe al menu
         di aprirsi, cioe il difetto che stiamo evitando al contrario */
      ['click', 'mousedown'].forEach(function (e) {
        sel.addEventListener(e, function (ev) { ev.stopPropagation(); });
      });
      sel.addEventListener('change', function (ev) {
        ev.stopPropagation();
        var o = sel.options[sel.selectedIndex];
        var riga = sel.closest('.pezzo');
        var box = riga && riga.querySelector('[data-av-pezzo]');
        var pz = riga && riga.querySelector('[data-av-prezzo]');
        if (box) { box.dataset.variante = o.value; box.dataset.prezzo = o.dataset.prezzo || box.dataset.prezzo; }
        if (pz) { pz.textContent = soldi(Number(o.dataset.prezzo || 0)); }
        conta();
      });
    });

    conta();

    function v_pagina() {
      var form = document.querySelector(radice.dataset.form || '#av-mg-form');
      var campo = form && form.querySelector('[name="id"]');
      return campo ? campo.value : null;
    }

    prendi.addEventListener('click', function () {
      if (prendi.dataset.occupato) { return; }
      prendi.dataset.occupato = '1';
      var atteso = prendi.textContent;
      prendi.textContent = prendi.dataset.attesa || atteso;

      var scelti = [];
      caselle.forEach(function (c) {
        if (c.checked && !c.disabled) { scelti.push(c.dataset.variante); }
      });

      /* la bandierina resta alzata per tutta la sequenza: finche e alzata,
         la spedizione assicurata non si aggiunge da sola in mezzo */
      inCorsoCarrello += 1;
      var vp = v_pagina();
      var i = 0;
      (function prossimo() {
        if (i >= scelti.length) {
          /* il prodotto della pagina per ultimo: il suo form porta con se la
             variante scelta in pagina e la quantita, e va inviato quando i
             compagni sono gia dentro */
          var form = document.querySelector(radice.dataset.form || '#av-mg-form');
          var suo = form && form.querySelector('[name="add"]');
          if (suo) { suo.click(); }
          attendiVariante(vp, 6000, function () {
            inCorsoCarrello -= 1;
            prendi.dataset.occupato = '';
            prendi.textContent = atteso;
            /* ora che la coda e libera, il sorvegliante puo fare il suo giro:
               se la spedizione assicurata va aggiunta, si aggiunge adesso */
            document.querySelectorAll('[data-av-protezione]').forEach(sincronizzaProt);
          });
          return;
        }
        var quale = scelti[i];
        var a = radice.querySelector('[data-av-scatto="' + quale + '"]');
        i++;
        if (!a) { prossimo(); return; }
        a.click();
        /* uno per volta, e non a tempo: si aspetta che il carrello lo
           confermi. Due aggiunte sovrapposte si pestano i piedi e il
           carrello ne perde una, senza dire niente. */
        attendiVariante(quale, 6000, function () { setTimeout(prossimo, 120); });
      }());
    });
  }

  /* La barra dei traguardi.

     Liquid la rende una volta, al caricamento. Poi il carrello cambia e i
     numeri invecchiano: quanto manca, quanto e piena, quali tappe sono prese.
     Quindi la si riscrive qui, leggendo il carrello vero.

     Si chiede /cart.js e non si leggono i prezzi dal cassetto: nel cassetto
     ci sono prezzi gia scontati, barrati e per riga, e sommarli a occhio da
     un numero che non e quello su cui la soglia si decide.

     Dal conto restano fuori i nostri servizi, spedizione assicurata e kit:
     hanno il tag `adville` e non sono gioielli. Regalare il kit a chi ha
     raggiunto la soglia grazie ai 2,99 della spedizione sarebbe un regalo
     comprato con un altro regalo. */
  function soldiCome(modello, centesimi) {
    var cifre = modello.replace(/[0-9]/g, '#');
    var virgola = modello.indexOf(',') > -1 && modello.indexOf('.') === -1;
    var v = (centesimi / 100).toFixed(2);
    return cifre.replace(/#+[.,]?#*/, virgola ? v.replace('.', ',') : v);
  }

  function disegnaBarra(barra, conta) {
    var d = barra.dataset;
    var t1 = Number(d.t1 || 0), t2 = Number(d.t2 || 0);
    if (!t2) { return; }
    var fuori = barra.closest('.av-mg-barra-fuori') || barra.parentNode;

    if (conta <= 0) { fuori.setAttribute('hidden', ''); return; }
    fuori.removeAttribute('hidden');
    d.conta = String(conta);

    /* in Italia la spedizione e' gratuita da sempre: il primo traguardo nasce
       preso, e il messaggio salta direttamente al regalo */
    var preso1 = d.t1Preso === '1' || conta >= t1;

    var dire = barra.querySelector('.dire');
    var modello = d.soldi || '0,00';
    if (dire) {
      if (!preso1 && conta < t1) {
        dire.textContent = (d.d1Vai || '%s').replace('%s', soldiCome(modello, t1 - conta));
      } else if (conta < t2) {
        dire.textContent = (d.d2Vai || '%s').replace('%s', soldiCome(modello, t2 - conta));
      } else {
        dire.textContent = d.d2Fatto || '';
      }
    }
    var riempita = barra.querySelector('.riempita');
    if (riempita) {
      riempita.style.width = Math.min(100, Math.round(conta * 100 / t2)) + '%';
    }
    var tacche = barra.querySelectorAll('.tacca');
    var tappe = barra.querySelectorAll('.tappa');
    [preso1, conta >= t2].forEach(function (ok, i) {
      if (tacche[i]) { tacche[i].classList.toggle('presa', ok); }
      if (tappe[i]) { tappe[i].classList.toggle('presa', ok); }
    });
  }

  var barraInCorso = false;
  function aggiornaBarra() {
    var barre = document.querySelectorAll('[data-av-barra]');
    if (!barre.length || barraInCorso) { return; }
    barraInCorso = true;
    fetch('/cart.js', {headers: {'Accept': 'application/json'}})
      .then(function (r) { return r.json(); })
      .then(function (c) {
        /* conta TUTTO, servizi compresi: vedi il commento in av-mg-barra.
           Una barra che non si muove quando il carrello si muove sembra
           rotta, e sembrarlo e' peggio che essere generosi. */
        barre.forEach(function (b) { disegnaBarra(b, c.total_price); });
      })
      .catch(function () {})
      .then(function () { barraInCorso = false; });
  }

  /* Il «+» sulle schede dei consigliati, dentro il cassetto.

     Quelle schede le disegna Kalles e il prodotto lo sceglie lui, quindi
     l'aggancio non possiamo renderlo dentro. E non si puo' nemmeno crearlo al
     volo: provato, un `data-action-atc` inserito dopo il caricamento e poi
     cliccato non aggiunge niente. Il tema li lega una volta sola all'avvio e
     non delega.

     Quindi gli agganci stanno gia' in pagina, resi da av-mg-scatti-tutti, e
     il «+» si limita a far scattare quello del prodotto giusto: l'aggiunta
     resta del tema, con la sua validazione e il suo cassetto.

     Sui prodotti con piu' varianti il «+» NON aggiunge: porta alla scheda.
     Un clic solo non puo' sapere se Oro o Argento, e indovinare vuol dire far
     arrivare il colore sbagliato. Si vede dalla differenza: pieno quando
     aggiunge, vuoto quando porta a scegliere. */
  function piuSuiConsigliati(drawer) {
    drawer.querySelectorAll('.t4s-minicart-recommendations__item').forEach(function (card) {
      if (card.querySelector('[data-av-piu]')) { return; }
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) { return; }
      var handle = (link.getAttribute('href') || '').split('/products/')[1];
      if (!handle) { return; }
      handle = handle.split('?')[0].split('#')[0];

      var scatto = document.querySelector('[data-av-handle="' + handle + '"]');
      var unica = scatto && scatto.dataset.avUnica === '1';

      var b = document.createElement(unica ? 'button' : 'a');
      b.className = 'av-mg-piu' + (unica ? ' pieno' : '');
      b.setAttribute('data-av-piu', '');
      b.textContent = '+';
      if (unica) {
        b.type = 'button';
        b.setAttribute('aria-label', b.getAttribute('aria-label') || '+');
        b.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (b.dataset.occupato) { return; }
          b.dataset.occupato = '1';
          scatto.click();
          setTimeout(function () { b.dataset.occupato = ''; }, 1500);
        });
      } else {
        b.setAttribute('href', link.getAttribute('href'));
      }
      /* L'occhio di Kalles apre l'anteprima: al suo posto va il «+», nello
         stesso riquadro e con lo stesso colore. Chi arriva fin li' vuole
         metterlo nel carrello, non guardarlo di nuovo: la foto e il prezzo
         li ha gia' davanti. */
      /* `--qv` sta per quickview: e' la classe vera del bottone con l'occhio,
         letta dal DOM del cassetto. I nomi che si trovano in giro
         (data-open-quickview, .t4s-quickview) su questo tema non esistono, e
         cercandoli il «+» finiva appiccicato di fianco invece che al posto
         suo. */
      var occhio = card.querySelector('.t4s-minicart-recommendations__item--qv,'
                                      + ' [data-open-quickview], .t4s-quickview');
      if (occhio && occhio.parentNode) {
        b.className += ' al-posto-occhio';
        occhio.parentNode.replaceChild(b, occhio);
      } else {
        var dove = card.querySelector('.t4s-minicart-recommendations__item--img') || card;
        dove.appendChild(b);
        if (getComputedStyle(dove).position === 'static') { dove.style.position = 'relative'; }
      }
    });
  }

  /* Il cassetto, sorvegliato.

     Il nostro blocco NON si inietta piu da JavaScript: ora Liquid lo rende
     dentro `.t4s-drawer__bottom`, e misurato sul posto quel fondo sopravvive
     a ogni cambio del carrello. Kalles ridisegna solo l elenco degli
     articoli.

     Resta una cosa da fare, e va fatta guardando il DOM: l elenco cambia, e
     con lui cambia se la spedizione assicurata e dentro o fuori e se il
     carrello e vuoto. Quindi si osserva l elenco e si rimette in pari la
     striscia. Niente chiamate a /cart.js a ogni mutazione: la risposta e
     gia in pagina.

     Si nasconde anche la bolla di WhatsApp e il selettore di lingua dell app
     mentre il cassetto e aperto: ci stanno sopra, e il selettore copriva la
     X che chiude il carrello. Il tema mette `is--opend-drawer` sul body, e
     per quei due basta il CSS: qui si aggiunge solo una classe nostra, cosi
     la regola non dipende da un nome del tema che un aggiornamento puo
     cambiare. */
  function cassetto() {
    var drawer = document.querySelector('#t4s-mini_cart');
    if (!drawer) { return; }

    function sistema() {
      drawer.querySelectorAll('[data-av-protezione]').forEach(function (n) {
        if (!n.dataset.legato) { protezione(n); } else { sincronizzaProt(n); }
      });
      aggiornaBarra();
      piuSuiConsigliati(drawer);
    }

    sistema();
    new MutationObserver(sistema).observe(drawer, {childList: true, subtree: true});

    /* aperto o chiuso: il tema lo scrive sul body, noi lo ripetiamo con un
       nome nostro perche il CSS non dipenda dal suo */
    function statoApertura() {
      var aperto = document.body.classList.contains('is--opend-drawer');
      document.documentElement.classList.toggle('av-mg-cassetto-aperto', aperto);
    }
    statoApertura();
    new MutationObserver(statoApertura)
      .observe(document.body, {attributes: true, attributeFilter: ['class']});
  }

  /* Il blocco compositions: le frecce fanno scorrere la fila delle foto e il
     contatore segue. Prima erano due `<i>` di decorazione accanto a un «1 / 8»
     fisso: sembravano bottoni, non facevano niente, e un bottone finto insegna
     alla cliente che i bottoni di questo sito non rispondono. */
  function compo(radice) {
    var fila = radice.querySelector('[data-av-compo-fila]');
    var quale = radice.querySelector('[data-av-compo-quale]');
    if (!fila) { return; }
    var pezzi = fila.querySelectorAll('.pezzo-compo');
    if (pezzi.length < 2) {
      var conta = radice.querySelector('[data-av-compo-conta]');
      if (conta) { conta.hidden = true; }   /* una foto sola non si sfoglia */
      return;
    }

    function dove() {
      var largo = pezzi[0].getBoundingClientRect().width || 1;
      return Math.round(fila.scrollLeft / largo);
    }
    function segna() {
      if (quale) { quale.textContent = Math.min(pezzi.length, dove() + 1); }
    }

    radice.querySelectorAll('[data-av-compo]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = dove() + Number(b.dataset.avCompo || 1);
        if (n < 0) { n = 0; }
        if (n > pezzi.length - 1) { n = pezzi.length - 1; }
        fila.scrollTo({left: pezzi[n].offsetLeft - fila.offsetLeft, behavior: 'smooth'});
      });
    });

    var attesa = null;
    fila.addEventListener('scroll', function () {
      if (attesa) { clearTimeout(attesa); }
      attesa = setTimeout(segna, 90);
    });
    segna();
  }

  /* La pillola risponde SUBITO al dito.

     Il colore si cambia navigando: la pagina si ricarica con ?variant= e il
     server rende la variante scelta, che e' la strada robusta. Ma fra il clic
     e la pagina nuova passa piu' di un secondo, e su questa scheda - che e'
     grossa, perche' le descrizioni del cliente arrivano a ventiduemila
     caratteri - in quel secondo non si muoveva niente. Un dito che non riceve
     risposta clicca di nuovo, poi smette e conclude che non funziona: e'
     esattamente il racconto che e' arrivato dal negozio.

     Qui non si tocca la navigazione, si risponde mentre parte: la pillola si
     riempie e la riga sopra cambia parola nello stesso istante del clic. Se la
     pagina nuova arriva, ha gia' lo stesso stato reso da Liquid e non si vede
     nessun salto. Se la rete e' lenta, almeno la scelta e' segnata.

     Vale anche per le pillole esaurite: scegliere una variante finita e' una
     scelta legittima, e la risposta giusta e' vederla scelta e trovare il
     bottone spento, non un clic che sembra perso. */
  function pillole(radice) {
    var tutte = radice.querySelectorAll('[data-av-pillola]');
    if (!tutte.length) { return; }
    var riga = radice.querySelector('.scelta b');
    var fine = radice.querySelector('.scelta .fine');
    tutte.forEach(function (p) {
      p.addEventListener('click', function () {
        tutte.forEach(function (x) {
          x.classList.remove('attiva');
          x.removeAttribute('aria-current');
        });
        p.classList.add('attiva');
        p.setAttribute('aria-current', 'true');
        if (riga) { riga.textContent = p.textContent.trim(); }
        if (fine) { fine.hidden = !p.classList.contains('spenta'); }
      });
    });
  }

  function avvia() {
    document.querySelectorAll('.av-mg-prodotto').forEach(pillole);
    document.querySelectorAll('.av-mg-collezione').forEach(collega);
    document.querySelectorAll('[data-av-galleria]').forEach(galleria);
    document.querySelectorAll('.av-mg-compo').forEach(compo);
    document.querySelectorAll('[data-av-protezione]').forEach(protezione);
    document.querySelectorAll('[data-av-bundle]').forEach(insieme);
    cassetto();
    aggiornaBarra();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia);
  } else {
    avvia();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('.av-mg-collezione');
    if (r) { collega(r); }
    var g = e.target.querySelector('[data-av-galleria]');
    if (g) { galleria(g); }
    var k = e.target.querySelector('.av-mg-compo');
    if (k) { compo(k); }
    var q = e.target.querySelector('.av-mg-prodotto');
    if (q) { pillole(q); }
  });
  window.AVMG = { collega: collega, galleria: galleria, protezione: protezione,
                  insieme: insieme, cassetto: cassetto, barra: aggiornaBarra,
                  compo: compo, pillole: pillole, avvia: avvia };
}());
